/**
 * Enum Cấp ngân sách
 */
export default {
    /**
     * TW
     */
    Central: 1,
    /**
     * Tỉnh
     */
    Province: 2,
    /**
     * Huyện
     */
    District: 3,
    /**
     * Xã
     */
    Ward: 4,
};
